import { SVGIcon } from '@progress/kendo-svg-icons';
import { SettingBooleanKeys, SettingsEnumLikeKeys, SettingsStringKeys, SettingValue } from '../../../../../services/settings-service';
import { DropdownList } from '../../../../components/inputs/DropdownListWithValueField';

export interface SettingsSectionType {
    name: string;
    path: string;
    icon: SVGIcon;
    groups: SettingsGroupType[];
}

export type SettingsGroupType = {
    name: string;
    id?: string;
} & ({ type: 'custom'; element: React.ReactNode } | { type: 'normal'; elements: SettingsElementType[] });

export type SettingsElementType = { searchTag?: string; id?: string } & (
    | {
          name: string;
          hint?: string;
          value: SettingBooleanKeys;
          type: 'bool';
      }
    | SettingsDropdownElement<SettingsEnumLikeKeys>
    | {
          hint?: string;
          name: string;
          type: 'text';
      }
    | {
          name: string;
          hint?: string;
          placeholder?: string;
          value: SettingsStringKeys;
          type: 'text-input';
      }
    | {
          element: React.ReactNode;
          type: 'custom';
      }
    | {
          name: string;
          hint?: string;
          to: string;
          type: 'link';
      }
);

export type SettingsDropdownElement<T extends SettingsEnumLikeKeys> = {
    name: string;
    hint?: string;
    value: T;
    options: DropdownList<SettingValue<T>>;
    type: 'dropdown';
};

// Helper function that infers T from the 'value' property, TS doesn't infer generic types from object literals
export function dropdownElement<T extends SettingsEnumLikeKeys>(
    element: SettingsDropdownElement<T> & { id?: string; searchTag?: string }
): SettingsDropdownElement<T> & { searchTag?: string } {
    return element;
}
